export const MultidayAppointmentTypes = {
  BOARDING: 'Boarding',
}

export const MultidayAppointmentTypesList = Object.values(
  MultidayAppointmentTypes,
)
